/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateDestinationForm,
  CreateDestinationForm$Outbound,
  CreateDestinationForm$outboundSchema,
} from "../components/createdestinationform.js";

export type CreateDataExportDestinationSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateDataExportDestinationSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateDataExportDestinationSecurity = {
  option1?: CreateDataExportDestinationSecurityOption1 | undefined;
  option2?: CreateDataExportDestinationSecurityOption2 | undefined;
};

export type CreateDataExportDestinationRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createDestinationForm: CreateDestinationForm;
};

/** @internal */
export type CreateDataExportDestinationSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateDataExportDestinationSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateDataExportDestinationSecurityOption1$Outbound,
    CreateDataExportDestinationSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createDataExportDestinationSecurityOption1ToJSON(
  createDataExportDestinationSecurityOption1:
    CreateDataExportDestinationSecurityOption1,
): string {
  return JSON.stringify(
    CreateDataExportDestinationSecurityOption1$outboundSchema.parse(
      createDataExportDestinationSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateDataExportDestinationSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateDataExportDestinationSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateDataExportDestinationSecurityOption2$Outbound,
    CreateDataExportDestinationSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createDataExportDestinationSecurityOption2ToJSON(
  createDataExportDestinationSecurityOption2:
    CreateDataExportDestinationSecurityOption2,
): string {
  return JSON.stringify(
    CreateDataExportDestinationSecurityOption2$outboundSchema.parse(
      createDataExportDestinationSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateDataExportDestinationSecurity$Outbound = {
  Option1?: CreateDataExportDestinationSecurityOption1$Outbound | undefined;
  Option2?: CreateDataExportDestinationSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateDataExportDestinationSecurity$outboundSchema: z.ZodMiniType<
  CreateDataExportDestinationSecurity$Outbound,
  CreateDataExportDestinationSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateDataExportDestinationSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateDataExportDestinationSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createDataExportDestinationSecurityToJSON(
  createDataExportDestinationSecurity: CreateDataExportDestinationSecurity,
): string {
  return JSON.stringify(
    CreateDataExportDestinationSecurity$outboundSchema.parse(
      createDataExportDestinationSecurity,
    ),
  );
}

/** @internal */
export type CreateDataExportDestinationRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateDestinationForm: CreateDestinationForm$Outbound;
};

/** @internal */
export const CreateDataExportDestinationRequest$outboundSchema: z.ZodMiniType<
  CreateDataExportDestinationRequest$Outbound,
  CreateDataExportDestinationRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createDestinationForm: CreateDestinationForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createDestinationForm: "CreateDestinationForm",
    });
  }),
);

export function createDataExportDestinationRequestToJSON(
  createDataExportDestinationRequest: CreateDataExportDestinationRequest,
): string {
  return JSON.stringify(
    CreateDataExportDestinationRequest$outboundSchema.parse(
      createDataExportDestinationRequest,
    ),
  );
}
